<template>
  <NuxtLayout>
    <NuxtPage />
    <client-only>
      <teleport to="body">
        <BasePopup v-if="globalPopupState.component" />
      </teleport>
    </client-only>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/es-mx';
import 'dayjs/locale/pt';
import 'dayjs/locale/pt-br';

useSeoMeta({
  title: 'Dr. Kegel: for Men\'s Health',
  ogTitle: 'Dr. Kegel: for Men\'s Health',
  description: 'Improve men’s health in 5 min/day. Feel confident & happy with the most downloaded intimate wellness app in the World',
  ogDescription: 'Improve men’s health in 5 min/day. Feel confident & happy with the most downloaded intimate wellness app in the World.',
});

const { globalPopupState } = usePopups();
const funnelConfig = useFunnelConfig();

if (funnelConfig.value.homePageConfig) {
  useAgeGate();
}

onMounted(async () => {
  const { callActionsAfterMounted } = await useInitApp();
  const pending = ageGatePending;
  if (pending) {
    await pending;
  }
  callActionsAfterMounted();
});
</script>
